import axios from 'axios';

var BookAPresentationForm = function( form ) {
    if ( !form ) {
        throw new Error( 'form is undefined' );
    }

    const errorMsgs = form.querySelectorAll( 'form-error-msg' );
    const submitBtn = form.querySelector( 'button[type=submit]' );

    form.addEventListener( 'submit', function( event ) {
        event.preventDefault();

        if ( submitBtn ) {
            submitBtn.disabled = true;
        }

        errorMsgs.forEach( msg =>  msg.classList.add( 'd-none' ) );

        axios.post( window.location.origin + form.getAttribute( 'action' ), new FormData( form ), {} ).then( ( response ) => {
            if ( response.status !== 200 ) {
                errorMsgs.forEach( msg => {
                    msg.innerHTML = 'Please check the form for errors and try again.'
                    msg.classList.remove( 'd-none' );
                } );
                submitBtn.disabled = false;
                return;
            }

            if ( !response.data.success ) {
                errorMsgs.forEach( msg => {
                    msg.innerHTML = response.data.error;
                    msg.classList.remove( 'd-none' );
                } );
                submitBtn.disabled = false;
                return
            }

            form.classList.add( 'd-none' );

            form.insertAdjacentHTML( 'afterend', `<p id="presentation-form-success-msg" class="success-msg">${response.data.msg}</p>` );

            const successMsg = document.querySelector( '#presentation-form-success-msg' );

            if ( !successMsg ) {
                return;
            }

            successMsg.scrollIntoView( {
                behaviour: 'smooth',
            } );
        } );
    } );
}

export default BookAPresentationForm;
